
define('text!common/views/commercial/creatives/manual-container-cta.html',[],function () { return '<a class="button button--tertiary button--large" href="<%=clickMacro%><%=baseUrl%>" data-link-name="viewall">\n    <%=viewalltext%>\n    <%=arrowRight%>\n</a>\n';});

